import type { RelativityFactors } from "./types";

/**
 * Bed-type relativity factors used by the Equivalency and Licensed
 * Equivalency calcs.
 *
 * Sourced from the actuarial pricing model (Schedule tab, row 6):
 * each factor weights a bed-type count when summing into a
 * facility's equivalency number. The downstream premium is
 * Equivalency × Rate, so these factors directly set the relative
 * price-per-bed of each care level.
 *
 * Memory Care is intentionally not represented here — the UW pricing
 * directive defines Equivalency and Total Lic over 4 census buckets
 * (Skilled / Assisted / Independent / Addl Exposure) and 3 licensed
 * buckets (SNF / ALF / ILF). Memory Care lives in the SoT for other
 * surfaces but is excluded from pricing.
 *
 * `addl` factor is TBD — the actuarial table left every Add'l-side
 * column (Adult Day Care / Hospice / Rehab / Home Health /
 * Physicians) blank. Defaulting to `0` keeps those beds out of the
 * equivalency total until UW supplies a number. Override per-call
 * if a submission needs a custom value.
 */
export const RELATIVITY: RelativityFactors = {
    skilled: 1.0,
    assisted: 0.35,
    independent: 0.15,
    addl: 0,
};
